exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-combinatie .list-select{margin-bottom:30px}.page-combinatie__sort-controls{color:#bbb;font-size:.8em;font-family:Merriweather}.page-combinatie__sort-control{cursor:pointer}.page-combinatie__sort-control:hover{color:#e96661}.page-combinatie__sort-control:first-child{text-align:left}.page-combinatie__sort-control:nth-child(2){text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d38de4ca","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/page-combinatie.vue
// module id = 73
// module chunks = 0